import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { topScreens } from '../../data/metrics';
import styles from './TopScreensSection.module.css';

const TopScreensSection = () => {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true
  });

  // Sort screens by screenViews in descending order
  const sortedScreens = [...topScreens].sort((a, b) => b.screenViews - a.screenViews);

  return (
    <section className={styles.topScreens} aria-labelledby="screens-title">
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 id="screens-title" className={styles.title}>
            Most Popular Screens
          </h2>
          <p className={styles.description}>
            Top screens by screen views, showcasing the features students rely on most.
          </p>
        </div>

        <motion.div
          ref={ref}
          className={styles.tableWrapper}
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : { opacity: 0 }}
          transition={{ duration: 0.6 }}
        >
          <table className={styles.table}>
            <thead>
              <tr>
                <th className={styles.rankHeader}>Rank</th>
                <th className={styles.nameHeader}>Screen Name</th>
                <th className={styles.viewsHeader}>Screen Views</th>
                <th className={styles.usersHeader}>Unique Users</th>
              </tr>
            </thead>
            <tbody>
              {sortedScreens.map((screen, index) => (
                <motion.tr
                  key={screen.name}
                  className={styles.tableRow}
                  initial={{ opacity: 0, x: -20 }}
                  animate={inView ? { opacity: 1, x: 0 } : { opacity: 0, x: -20 }}
                  transition={{ duration: 0.3, delay: index * 0.02 }}
                >
                  <td className={styles.rankCell}>#{index + 1}</td>
                  <td className={styles.nameCell}>{screen.name}</td>
                  <td className={styles.viewsCell}>{screen.screenViews.toLocaleString()}</td>
                  <td className={styles.usersCell}>{screen.uniqueUsers.toLocaleString()}</td>
                </motion.tr>
              ))}
            </tbody>
          </table>
        </motion.div>
      </div>
    </section>
  );
};

export default TopScreensSection;
